import { trpc } from '@/shared/api';

/** HOME 기업 고객 사례(landing.listTestimonials) — 운영자가 등록한 카드. 배열 순서가 노출 순서다. 하나라도 있으면 상품 후기 대신 쓴다. */
export const useLandingTestimonialsQuery = () =>
  trpc.landing.listTestimonials.useQuery(undefined, { retry: false });
